import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Stack from '@mui/system/Stack';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

export const SupportText = (): ReactElement => {
  const { t } = useTranslation('integrations');

  return (
    <Stack
      sx={{
        alignItems: 'center',
      }}
    >
      <Typography>{t('integration/sapConcur.supportQuestion')}</Typography>
      <Typography>
        {t('integration/sapConcur.supportContact')}
        <Typography component="span" sx={{ color: 'blue' }}>
          {' '}
          <Link
            href="https://www.safeture.com/contact-us/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Safeture support
          </Link>
        </Typography>
      </Typography>
    </Stack>
  );
};
